<template>
  <div v-if="client.client_history_communications">
    <!-- {{ client.client_history_communications }} -->
    <history-list :history="client.client_history_communications" class="scrollable" />

    <modal :show="showModal" :showBtn="true" @close="toggleModal" :dark="true" :outside="false">
      <transition name="showmodal">
        <orders-modal :large="true" @close="toggleModal" />
      </transition>
    </modal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import historyList from '@/components/lists/history/historyList'
import ordersModal from '@/components/modals/orders/ordersModal'

export default {
    name: 'history-view',
    components: {
        historyList,
        ordersModal,
    },
    props: {
        client: {
            required: true,
        },
    },
    //   computed: {
    //     ...mapGetters({
    //       historyCommunication: "historyCommunication",
    //     }),
    //   },
    computed: {
        ...mapGetters({
            showModal: 'orders/showModal',
        }),
    },
    methods: {
        ...mapActions({
            fetchHistoryCommunication: 'fetchHistoryCommunication',
        }),
        ...mapMutations({
            toggleModal: 'orders/setToggleModal',
        }),
    },
    //   created() {
    //     this.fetchHistoryCommunication(this.client.id);
    //   },
}
</script>

<style lang="scss">
.scrollable {
  overflow: scroll !important;
  height: 60vh !important;
}
</style>
